import { cn } from "../lib/utils";
import { forwardRef } from "react";

interface CheckMatyLoaderProps {
  size?: "sm" | "md" | "lg";
  showText?: boolean;
  className?: string;
  fullScreen?: boolean;
}

const sizeMap = {
  sm: { svg: 32, text: "text-xs" },
  md: { svg: 56, text: "text-sm" },
  lg: { svg: 80, text: "text-base" },
};

export const CheckMatyLoader = forwardRef<HTMLDivElement, CheckMatyLoaderProps>(
  function CheckMatyLoader({ size = "md", showText = true, className, fullScreen = false }, ref) {
    const { svg: svgSize, text: textSize } = sizeMap[size];

    const content = (
      <div ref={fullScreen ? undefined : ref} className={cn("text-center", className)}>
        <svg
          width={svgSize}
          height={svgSize}
          viewBox="0 0 24 24"
          fill="none"
          className="mx-auto mb-4"
          aria-hidden="true"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
            opacity="0.3"
            className="text-primary"
          />
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
            strokeDasharray="63"
            strokeDashoffset="63"
            className="text-primary animate-[circle-fill_1.5s_ease-out_forwards]"
          />
          <path
            d="M8 12l3 3 5-5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="15"
            strokeDashoffset="15"
            className="text-primary animate-[check-draw_0.5s_ease-out_0.5s_forwards]"
          />
        </svg>
        {showText && <div className={cn("font-medium text-primary", textSize)}>CheckMaty</div>}
      </div>
    );

    if (fullScreen) {
      return (
        // Fixed dark brand background (Plasser-Navy) for consistency with index.html and logout transition
        <div
          ref={ref}
          className="min-h-screen flex items-center justify-center"
          style={{ backgroundColor: "#0b1f33" }}
        >
          {content}
        </div>
      );
    }

    return content;
  },
);
